import { render, staticRenderFns } from "./AllChannelActivity.vue?vue&type=template&id=127c037b&scoped=true"
import script from "./AllChannelActivity.vue?vue&type=script&lang=js"
export * from "./AllChannelActivity.vue?vue&type=script&lang=js"
import style0 from "./AllChannelActivity.vue?vue&type=style&index=0&id=127c037b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c037b",
  null
  
)

export default component.exports